import { render, staticRenderFns } from "./CompanyOrderDetails.vue?vue&type=template&id=2af8de46&scoped=true&"
import script from "./CompanyOrderDetails.vue?vue&type=script&lang=js&"
export * from "./CompanyOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./CompanyOrderDetails.vue?vue&type=style&index=0&id=2af8de46&lang=scss&scoped=true&"
import style1 from "./CompanyOrderDetails.vue?vue&type=style&index=1&id=2af8de46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af8de46",
  null
  
)

export default component.exports